import { useEffect, useState } from "react";
import { Loader2, ChevronDown, ChevronRight, MapPin } from "lucide-react";
import api from "@/lib/api";

const STATUT_C = {
  "sécurisé": "text-emerald-400",
  "en litige": "text-red-400",
  "en cours": "text-amber-400",
};
const fmtDate = (iso) => {
  try { return new Date(iso).toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" }); }
  catch { return iso; }
};

export default function JournalPanel() {
  const [groups, setGroups] = useState(null);
  const [open, setOpen] = useState({});

  useEffect(() => {
    api.get("/admin/agent-journal").then((r) => setGroups(r.data)).catch(() => setGroups([]));
  }, []);

  const toggle = (email) => setOpen((o) => ({ ...o, [email]: !o[email] }));

  return (
    <div>
      <div className="mb-6">
        <h1 className="font-heading text-4xl lg:text-5xl text-foreground">Journal des saisies</h1>
        <p className="text-muted-foreground mt-1">Historique des parcelles enregistrées par chaque agent.</p>
      </div>

      {groups === null ? (
        <div className="p-16 grid place-items-center"><Loader2 className="w-6 h-6 animate-spin text-secondary" /></div>
      ) : groups.length === 0 ? (
        <div className="p-16 text-center text-muted-foreground border border-border rounded-xl">Aucune saisie pour le moment.</div>
      ) : (
        <div className="space-y-4" data-testid="journal-list">
          {groups.map((g) => (
            <div key={g.email} className="border border-border rounded-xl overflow-hidden" data-testid="journal-group">
              <button onClick={() => toggle(g.email)} data-testid="journal-toggle"
                className="w-full flex items-center justify-between px-5 py-4 bg-card hover:bg-card/70 transition-colors">
                <div className="flex items-center gap-3">
                  {open[g.email] ? <ChevronDown className="w-4 h-4 text-secondary" /> : <ChevronRight className="w-4 h-4 text-muted-foreground" />}
                  <div className="text-left">
                    <p className="font-medium text-foreground">{g.name}</p>
                    <p className="text-xs text-muted-foreground">{g.email}</p>
                  </div>
                </div>
                <span className="inline-flex items-center gap-2 text-sm text-secondary">
                  <MapPin className="w-4 h-4" /> {g.count} parcelle{g.count > 1 ? "s" : ""}
                </span>
              </button>

              {open[g.email] && (
                <div className="divide-y divide-border border-t border-border">
                  {g.parcels.map((p) => (
                    <div key={p.id} className="grid grid-cols-2 md:grid-cols-6 gap-2 px-5 py-3 text-sm items-center" data-testid="journal-parcel">
                      <span className="font-mono text-secondary">{p.reference}</span>
                      <span className="text-muted-foreground">{p.localite}</span>
                      <span className="text-muted-foreground">{p.region}</span>
                      <span>{p.superficie} ha</span>
                      <span className={STATUT_C[p.statut] || "text-muted-foreground"}>{p.statut}</span>
                      <span className="text-muted-foreground text-right">{fmtDate(p.created_at)}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
